// "use strict";
"use strict";

(() => {
  /******************************************************************/
  /* GLOBAL VARS
  /******************************************************************/

  let scData;
  let minSubtotalPriceValue;
  let shippingPrice;
  let currentCountry;

  // Guard gegen parallele handleFreeGift-Aufrufe
  let isFreeGiftProcessing = false;
  let isFreeGift2Processing = false;
  let isCheeringBarSubtotalSyncInProgress = false;

  let cartMessageSteps;
  let deliveryBarValueEl;
  let deliveryBarLeftTextEl;
  let deliveryBarFinalTextEl;
  let deliveryBarStepLineEl;
  let giftIcon;
  let deliveryIcon;

  const refreshCheeringBarElements = () => {
    cartMessageSteps = document.querySelector("#sidebar-cart .CartMessage__Steps");
    deliveryBarValueEl = document.querySelector(
      "#sidebar-cart .js-cart-drawer-delivery-left-value"
    );
    deliveryBarLeftTextEl = document.querySelector(
      "#sidebar-cart .CartMessage__Steps__Text-left"
    );
    deliveryBarFinalTextEl = document.querySelector(
      "#sidebar-cart .CartMessage__Steps__Text-final"
    );
    deliveryBarStepLineEl = document.querySelector(
      "#sidebar-cart .CartMessage__StepsLines__Active"
    );
    giftIcon = document.querySelector("#sidebar-cart .CartMessage__StepsLines__Gift");
    deliveryIcon = document.querySelector(
      "#sidebar-cart .CartMessage__StepsLines__Delivery"
    );
  };

  const getSidebarCartValuesEl = () => {
    return document.querySelector("#sidebar-cart .Cart__values");
  };

  // Ob das Gift-Icon in der CheeringBar angezeigt wird:
  // true wenn (a) globales Gift aktiv ODER (b) der separate CheeringBar-Override aktiv ist
  const isGiftCheeringBarEnabled = () => {
    return window.cartDrawerEnableGift || window.cartDrawerEnableGiftCheeringBar;
  };

  /******************************************************************/
  /* PLACE DCART
  /******************************************************************/

  window.scThemeConfig = {
    cartDiscountSelector: {
      path: "#shopify-section-cart-template section div.Container div.PageContent form.Cart footer.Cart__Footer div.Cart__Recap p.Cart__Total",
      type: 1,
    },
    cartTotalSelector: {
      path: "#shopify-section-cart-template section div.Container div.PageContent form.Cart footer.Cart__Footer div.Cart__Recap p.Cart__Total span",
      type: 0,
    },
    ajaxDicountSelector: {
      path: "#sidebar-cart form.Cart div.Drawer__Footer div.Drawer__Footer__Inner div.Drawer__Footer__Coupon div.Drawer__Footer__Coupon-content div.Drawer__Footer__Coupon-dcart",
      type: 1,
    },
  };

  /******************************************************************/
  /* HELPER: Safe Money Format
  /******************************************************************/

  const safeFormatMoney = (cents) => {
    try {
      if (typeof Shopify !== "undefined" && typeof Shopify.scFormatMoney === "function") {
        return Shopify.scFormatMoney(cents);
      }
      const amount = (cents / 100).toFixed(2).replace(".", ",");
      return amount + " €";
    } catch (e) {
      console.warn("safeFormatMoney Fehler:", e);
      const amount = (cents / 100).toFixed(2).replace(".", ",");
      return amount + " €";
    }
  };

  const getSafeScDiscountData = () => {
    try {
      const raw = sessionStorage.getItem("scDiscountData");
      if (!raw || raw === "undefined" || raw === "null") {
        return null;
      }
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (error) {
      if (DEBUG_CART_DRAWER) {
        console.warn("[bs-cart-drawer] invalid scDiscountData in sessionStorage", error);
      }
      return null;
    }
  };

  const DEBUG_CART_DRAWER = false;

  const debugCheering = (label, extra) => {
    if (!DEBUG_CART_DRAWER) return;
    console.log("[bs-cart-drawer][consent-debug]", {
      label,
      country: currentCountry || null,
      minSubtotalPriceValue:
        minSubtotalPriceValue !== undefined ? minSubtotalPriceValue : null,
      shippingPrice: shippingPrice !== undefined ? shippingPrice : null,
      cartTotalPriceFloat: getSidebarCartValuesEl()?.dataset
        .cartTotalPriceFloat || null,
      ...extra,
      timestamp: Date.now(),
    });
  };

  const debugInteraction = (label, extra) => {
    if (!DEBUG_CART_DRAWER) return;
    console.warn("[bs-cart-drawer][interaction-debug]", {
      label,
      ...extra,
      timestamp: Date.now(),
    });
  };

  const ensureCartValuesFromApiIfNeeded = async (reason) => {
    const cartValuesEl = getSidebarCartValuesEl();
    const cartTotalPriceFloat = parseFloat(
      cartValuesEl?.dataset?.cartTotalPriceFloat || 0
    );
    const sidebarItemsCount = document.querySelectorAll(
      "#sidebar-cart .Drawer__Container .CartItemWrapper[data-price]"
    ).length;

    if (!(sidebarItemsCount > 0 && cartTotalPriceFloat <= 0)) {
      return;
    }

    debugCheering("ensureCartValuesFromApiIfNeeded:start", {
      reason,
      sidebarItemsCount,
      cartTotalPriceFloat,
    });

    try {
      const response = await fetch("/cart.js", { credentials: "same-origin" });
      if (!response.ok) {
        throw new Error("cart.js fetch failed: " + response.status);
      }
      const cart = await response.json();

      if (cartValuesEl && cart.total_price !== undefined) {
        cartValuesEl.dataset.cartTotalPriceFloat = (
          cart.total_price / 100
        ).toFixed(2);
        cartValuesEl.dataset.cartTotalPrice = String(cart.total_price);
      }

      debugCheering("ensureCartValuesFromApiIfNeeded:done", {
        reason,
        syncedTotalPriceFloat: cart.total_price / 100,
        itemCount: cart.item_count,
      });
    } catch (error) {
      debugCheering("ensureCartValuesFromApiIfNeeded:error", {
        reason,
        error: error?.message || String(error),
      });
    }
  };

  const runCheeringBarRecoveryPass = () => {
    debugCheering("runCheeringBarRecoveryPass:start", {
      hasSidebarCart: Boolean(document.querySelector("#sidebar-cart")),
      hasSteps: Boolean(document.querySelector("#sidebar-cart .CartMessage__Steps")),
    });
    ensureCartValuesFromApiIfNeeded("runCheeringBarRecoveryPass").finally(() => {
      checkGeoLocation();
      totalCalculation(false);
      cheeringBar();
      showHideCheeringBar();
      debugCheering("runCheeringBarRecoveryPass:end", {
        progressWidth:
          document.querySelector("#sidebar-cart .CartMessage__StepsLines__Active")
            ?.style?.width || null,
        leftValue:
          document.querySelector("#sidebar-cart .js-cart-drawer-delivery-left-value")
            ?.textContent || null,
      });
    });
  };

  const scheduleConsentRecoveryPasses = (reason) => {
    debugCheering("scheduleConsentRecoveryPasses", { reason });
    const delays = [80, 240, 520, 900];
    delays.forEach((delay) => {
      setTimeout(() => {
        debugCheering("scheduledRecoveryPass", { reason, delay });
        runCheeringBarRecoveryPass();
      }, delay);
    });

    const body = document.body;
    if (!body) return;

    let observerTimeout = null;
    const observer = new MutationObserver(() => {
      clearTimeout(observerTimeout);
      observerTimeout = setTimeout(() => {
        debugCheering("mutationSettledRecoveryPass", { reason });
        runCheeringBarRecoveryPass();
      }, 120);
    });

    observer.observe(body, { childList: true, subtree: true });
    setTimeout(() => {
      observer.disconnect();
      clearTimeout(observerTimeout);
      debugCheering("mutationObserverDisconnected", { reason });
    }, 2500);
  };

  /******************************************************************/
  /* DOMContentLoaded
  /******************************************************************/

  document.addEventListener("DOMContentLoaded", async () => {
    scData = getSafeScDiscountData();
    const cartDrawer = document.querySelector("#sidebar-cart");
    debugInteraction("DOMContentLoaded:init", {
      hasCartDrawer: Boolean(cartDrawer),
    });

    window.unlockCheckoutButton();

    checkGeoLocation();
    toggleDCart();

    // Auf der Cart-Seite (kein Drawer) Geschenk-Logik nach Page-Load ausführen.
    // rerenderCart wird dort nie gefeuert, da Mengenänderungen per Form-Submit + Reload passieren.
    if (!cartDrawer && document.querySelector(".Cart__ItemList")) {
      const runGiftHandlersOnCartPage = async () => {
        let retries = 0;
        while (!currentCountry && retries < 20) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          retries++;
        }
        if (window.cartDrawerEnableGift && (currentCountry === "DE" || currentCountry === "AT" || currentCountry === "CH")) {
          await handleFreeGift();
        }
        if (window.cartDrawerEnableGift2 && (currentCountry === "DE" || currentCountry === "AT" || currentCountry === "CH")) {
          await handleFreeGift2();
        }
      };
      runGiftHandlersOnCartPage();
    }

    window.addEventListener("gdprConsentUpdated", function () {
      debugCheering("event:gdprConsentUpdated");
      scheduleConsentRecoveryPasses("gdprConsentUpdated");
    });
    window.addEventListener("CookiebotOnAccept", function () {
      debugCheering("event:CookiebotOnAccept");
      scheduleConsentRecoveryPasses("CookiebotOnAccept");
    });
    window.addEventListener("CookiebotOnConsentReady", function () {
      debugCheering("event:CookiebotOnConsentReady");
      scheduleConsentRecoveryPasses("CookiebotOnConsentReady");
    });

    document.addEventListener("click", function (event) {
      const acceptButton = event.target.closest(
        "#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection, .CybotCookiebotDialogBodyButton[data-action='accept'], [data-cookieconsent='accept']"
      );
      if (!acceptButton) return;

      debugCheering("event:CookieConsentAcceptClickFallback", {
        buttonId: acceptButton.id || null,
        buttonClass: acceptButton.className || null,
      });
      scheduleConsentRecoveryPasses("CookieConsentAcceptClickFallback");
    });

    document.addEventListener("rerenderCart", () => {
      debugInteraction("event:rerenderCart");
      const targetObserver = new MutationObserver((mutationsList, observer) => {
        observer.disconnect();
        debugInteraction("observer:rerenderCart:mutation", {
          mutationCount: mutationsList.length,
        });

        totalCalculation(false);

        if (scData?.stage === "complete") {
          dCartCalculation();
        }

        cheeringBar();
        showHideCheeringBar();
        toggleDCart();

        // Gift 1 + Gift 2 sequentiell ausführen um Race Conditions zu vermeiden
        // Falls currentCountry noch nicht gesetzt ist (GeoLocation pending), kurz warten
        const runGiftHandlers = async () => {
          let retries = 0;
          while (!currentCountry && retries < 20) {
            await new Promise((resolve) => setTimeout(resolve, 100));
            retries++;
          }

          if (
            window.cartDrawerEnableGift &&
            (currentCountry === "DE" ||
              currentCountry === "AT" ||
              currentCountry === "CH")
          ) {
            await handleFreeGift();
          }

          if (
            window.cartDrawerEnableGift2 &&
            (currentCountry === "DE" ||
              currentCountry === "AT" ||
              currentCountry === "CH")
          ) {
            await handleFreeGift2();
          }

          // Checkout-Button freigeben falls keine Gift-Handler aktiv waren
          if (!window.cartDrawerEnableGift && !window.cartDrawerEnableGift2) {
            window.unlockCheckoutButton();
          }
        };
        runGiftHandlers();

        if (
          currentCountry !== "DE" &&
          currentCountry !== "AT" &&
          currentCountry !== "CH"
        ) {
          handleOtherLocations();
        }
      });

      if (cartDrawer) {
        targetObserver.observe(cartDrawer, {
          childList: true,
          subtree: true,
        });
        debugInteraction("observer:rerenderCart:attached");
      }
    });

    document.addEventListener("click", function (event) {
      const actionEl = event.target.closest(
        "#sidebar-cart [data-action], #sidebar-cart .QuantitySelector__Button, #sidebar-cart .CartItem__Remove, #sidebar-cart .CartItem__Actions__UpsellBtn"
      );
      if (!actionEl) return;

      debugInteraction("event:sidebar-cart:click", {
        action: actionEl.getAttribute("data-action") || null,
        className: actionEl.className || null,
      });
    });

    document.addEventListener("change", function (event) {
      const inputEl = event.target.closest(
        "#sidebar-cart .QuantitySelector__CurrentQuantity, #sidebar-cart input[name='updates[]']"
      );
      if (!inputEl) return;

      debugInteraction("event:sidebar-cart:change", {
        name: inputEl.getAttribute("name") || null,
        value: inputEl.value || null,
        className: inputEl.className || null,
      });
    });

    document.addEventListener("crosstheme:cart:update", (event) => {
      event.stopImmediatePropagation();
      if (window.CrossTheme && typeof window.CrossTheme.removeEventListeners === "function") {
        window.CrossTheme.removeEventListeners();
      }
      debugInteraction("event:crosstheme:cart:update", event.detail);
      const quantityToAdd = event.detail?.itemCount || event.detail?.item_count || 1;
      document.dispatchEvent(new CustomEvent("product:added", {
        detail: {
          quantity: quantityToAdd
        }
      }));
    }, { capture: true });

    document.addEventListener("crosstheme:cart:open", (event) => {
      event.stopImmediatePropagation();
      if (window.CrossTheme && typeof window.CrossTheme.removeEventListeners === "function") {
        window.CrossTheme.removeEventListeners();
      }
      debugInteraction("event:crosstheme:cart:open");
      const openBtn = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
      if (openBtn) {
        openBtn.click();
      }
    }, { capture: true });
  });

  /******************************************************************/
  /* DCART EVENT LISTENER
  /******************************************************************/

  window.addEventListener("sc:discount.init", function () {
    dCartCalculation();
  });

  window.addEventListener("sc:discount.calculated", () => {
    dCartCalculation();
  });

  window.addEventListener("sc:discount.remove", () => {
    dCartCalculation();
  });

  window.addEventListener("sc:discount.error", () => {
    dCartCalculation();
  });

  /******************************************************************/
  /* WINDOW FUNCTIONS - LOCK/UNLOCK CHECKOUT BUTTON
  /******************************************************************/

  window.lockCheckoutButton = () => {
    const checkoutButton = document.querySelector(".Cart__Checkout");
    if (checkoutButton) {
      checkoutButton.disabled = true;
    }
  };

  window.unlockCheckoutButton = () => {
    const checkoutButton = document.querySelector(".Cart__Checkout");
    if (checkoutButton) {
      checkoutButton.disabled = false;

      document
        .querySelectorAll(".CartItemWrapper.disable-click")
        .forEach((disableClick) => {
          disableClick.classList.remove("disable-click");
        });
    }
  };

  /******************************************************************/
  /* GEOLOCATION
  /******************************************************************/

  const checkGeoLocation = () => {
    // Guard: wenn shippingrates noch nicht da sind, kurz warten und erneut versuchen
    if (!window.shippingrates) {
      setTimeout(checkGeoLocation, 50);
      return;
    }

    fetch("/browsing_context_suggestions.json")
      .then((response) => response.json())
      .then((json) => {
        currentCountry = json.detected_values.country.handle;
        switch (currentCountry) {
          case "DE":
            minSubtotalPriceValue =
              window.shippingrates.de?.minSubtotalPriceValue ?? 0;
            shippingPrice = window.shippingrates.de?.priceValue ?? 0;
            break;
          case "AT":
            minSubtotalPriceValue =
              window.shippingrates.at?.minSubtotalPriceValue ?? 0;
            shippingPrice = window.shippingrates.at?.priceValue ?? 0;
            break;
          case "CH":
            minSubtotalPriceValue =
              window.shippingrates.ch?.minSubtotalPriceValue ?? 0;
            shippingPrice = window.shippingrates.ch?.priceValue ?? 0;
            break;
          default:
            minSubtotalPriceValue = 0;
            shippingPrice = 0;
            break;
        }

        cheeringBar();
      });
  };

  /******************************************************************/
  /* HANDLE OTHER LOCATIONS
  /******************************************************************/

  const handleOtherLocations = () => {
    const cartMessageSteps = document.querySelector(
      "#sidebar-cart .CartMessage__Steps"
    );
    const drawerFooter = document.querySelector(
      "#sidebar-cart .Drawer__Footer"
    );
    const drawerFooterTotal = document.querySelector(
      "#sidebar-cart .Drawer__Footer__Total"
    );
    const drawerFooterDelivery = document.querySelector(
      "#sidebar-cart .Drawer__Footer__Delivery"
    );

    if (cartMessageSteps) {
      cartMessageSteps.style.display = "none";
    }

    if (drawerFooter) {
      drawerFooter.style.removeProperty("height");
    }

    if (drawerFooterTotal) {
      drawerFooterTotal.style.display = "none";
    }

    if (drawerFooterDelivery) {
      drawerFooterDelivery.innerHTML =
        "* Die Versandkosten werden im Checkout berechnet.";
      drawerFooterDelivery.style.bottom = "32px";
      drawerFooterDelivery.style.lineHeight = "20px";
    }
  };

  /******************************************************************/
  /* CHEERING BAR
  /******************************************************************/

  const dispatchCheeringBarUpdatedEvent = () => {
    refreshCheeringBarElements();

    const detail = {
      country: currentCountry || null,
      progressWidth: deliveryBarStepLineEl?.style.width || "0%",
      leftText: deliveryBarLeftTextEl?.textContent?.trim() || "",
      finalText: deliveryBarFinalTextEl?.textContent?.trim() || "",
      remainingValue: deliveryBarValueEl?.textContent?.trim() || "",
      giftVisible: giftIcon ? giftIcon.style.display !== "none" : false,
      timestamp: Date.now(),
    };

    window.dispatchEvent(
      new CustomEvent("cart:cheering-bar-updated", {
        detail,
      })
    );
  };

  const cheeringBar = () => {
    refreshCheeringBarElements();

    const cartItems = document.querySelectorAll(
      ".Drawer__Container .CartItemWrapper[data-price]"
    );
    const cartValuesEl = getSidebarCartValuesEl();
    let subtotalPrice = parseFloat(
      cartValuesEl?.dataset.cartTotalPriceFloat || 0
    );

    let noDeliveryItemsTotalPrice = 0;
    let hasItemWithDeliveryRequired = false;

    if (scData?.stage === "complete") {
      const scSubtotalPrice = parseFloat(scData?.totalCents / 100);
      if (Number.isFinite(scSubtotalPrice) && scSubtotalPrice > 0) {
        subtotalPrice = scSubtotalPrice;
      }
    }

    debugInteraction("cheeringBar:start", {
      cartItemsCount: cartItems.length,
      subtotalPrice,
      currentCountry,
      minSubtotalPriceValue,
      scDataStage: scData?.stage || null,
      scDataTotalCents: scData?.totalCents ?? null,
    });

    if (
      cartItems.length > 0 &&
      subtotalPrice <= 0 &&
      !isCheeringBarSubtotalSyncInProgress
    ) {
      isCheeringBarSubtotalSyncInProgress = true;
      fetch("/cart.js", { credentials: "same-origin" })
        .then((response) => {
          if (!response.ok) {
            throw new Error("cart.js fetch failed: " + response.status);
          }
          return response.json();
        })
        .then((cart) => {
          const sidebarValuesEl = getSidebarCartValuesEl();
          if (sidebarValuesEl && cart.total_price !== undefined) {
            sidebarValuesEl.dataset.cartTotalPriceFloat = (
              cart.total_price / 100
            ).toFixed(2);
            sidebarValuesEl.dataset.cartTotalPrice = String(cart.total_price);
          }
          debugInteraction("cheeringBar:subtotalSyncFromApi", {
            syncedTotalPriceFloat:
              cart.total_price !== undefined ? cart.total_price / 100 : null,
            itemCount: cart.item_count,
          });
          cheeringBar();
        })
        .catch((error) => {
          debugInteraction("cheeringBar:subtotalSyncFromApi:error", {
            error: error?.message || String(error),
          });
        })
        .finally(() => {
          isCheeringBarSubtotalSyncInProgress = false;
        });
      return;
    }

    // Geschenk-Varianten aus der no-shipping-Berechnung ausschließen
    const giftVariantId = window.cartDrawerGiftVariantId
      ? parseInt(window.cartDrawerGiftVariantId)
      : null;
    const gift2VariantId = window.cartDrawerGift2VariantId
      ? parseInt(window.cartDrawerGift2VariantId)
      : null;

    cartItems.forEach((cartItem) => {
      const itemVariantId = cartItem.dataset.variantId
        ? parseInt(cartItem.dataset.variantId)
        : null;

      if (giftVariantId && itemVariantId === giftVariantId) {
        return;
      }
      if (gift2VariantId && itemVariantId === gift2VariantId) {
        return;
      }

      if (cartItem.dataset.reqShipping == "false") {
        noDeliveryItemsTotalPrice += parseFloat(cartItem.dataset.price / 100);
      } else {
        hasItemWithDeliveryRequired = true;
      }
    });

    if (hasItemWithDeliveryRequired) {
      switch (currentCountry) {
        case "DE":
        case "AT":
          handleCheeringBar(subtotalPrice, noDeliveryItemsTotalPrice);
          break;
        case "CH":
          handleCheeringBarCH(subtotalPrice, noDeliveryItemsTotalPrice);
          break;
        default:
          handleCheeringBarOtherLocation(
            subtotalPrice,
            noDeliveryItemsTotalPrice
          );
          break;
      }
    } else {
      if (deliveryIcon) {
        deliveryIcon.style.left = "100%";
      }

      if (giftIcon) {
        giftIcon.style.display = "none";
      }

      if (deliveryBarStepLineEl) {
        deliveryBarStepLineEl.style.width = "0%";
      }

      if (deliveryBarValueEl) {
        deliveryBarValueEl.innerHTML = safeFormatMoney(
          minSubtotalPriceValue * 100
        );
      }
    }

    debugInteraction("cheeringBar:end", {
      progressWidth: deliveryBarStepLineEl?.style.width || null,
      leftValue: deliveryBarValueEl?.textContent?.trim() || null,
      hasItemWithDeliveryRequired,
    });
  };

  const handleCheeringBar = (subtotalPrice, noDeliveryItemsTotalPrice) => {
    refreshCheeringBarElements();

    let deliveryIconPosition;
    let subtotalPriceWithoutNoShippingItems =
      subtotalPrice - noDeliveryItemsTotalPrice;

    if (isGiftCheeringBarEnabled()) {
      const minPriceForGift = parseFloat(window.cartDrawerMinPriceForGift);
      const percentPerEuro = 100 / minPriceForGift;

      if (deliveryBarStepLineEl) {
        deliveryBarStepLineEl.style.width =
          Math.min(subtotalPriceWithoutNoShippingItems * percentPerEuro, 100) +
          "%";
      }

      if (giftIcon) {
        giftIcon.style.right = "0";
        giftIcon.style.display = "block";
      }

      deliveryIconPosition = (minSubtotalPriceValue * 100) / minPriceForGift;
      if (deliveryIcon) {
        deliveryIcon.style.left = deliveryIconPosition + "%";
      }

      if (currentCountry === "AT" && cartMessageSteps && giftIcon) {
        cartMessageSteps.style.height = "105px";
        const giftIconSpan = giftIcon.querySelector("span");
        if (giftIconSpan) {
          giftIconSpan.style.width = "60px";
          giftIconSpan.style.lineHeight = "12px";
          giftIconSpan.style.bottom = "-10px";
        }
      }

      if (minSubtotalPriceValue > subtotalPriceWithoutNoShippingItems) {
        let remainingPriceFreeShipping =
          parseFloat(minSubtotalPriceValue) -
          parseFloat(subtotalPriceWithoutNoShippingItems);

        if (deliveryBarFinalTextEl) {
          deliveryBarFinalTextEl.style.display = "none";
        }
        if (deliveryBarLeftTextEl) {
          deliveryBarLeftTextEl.style.display = "block";
        }
        if (deliveryBarValueEl) {
          deliveryBarValueEl.textContent = safeFormatMoney(
            remainingPriceFreeShipping * 100
          );
        }
      } else {
        let remainingPriceFreeGift =
          minPriceForGift - parseFloat(subtotalPriceWithoutNoShippingItems);

        if (deliveryBarFinalTextEl) {
          deliveryBarFinalTextEl.style.display = "block";
          deliveryBarFinalTextEl.textContent =
            "Noch " +
            safeFormatMoney(remainingPriceFreeGift * 100) +
            " bis zum Geschenk";
        }
        if (deliveryBarLeftTextEl) {
          deliveryBarLeftTextEl.style.display = "none";
        }

        if (
          subtotalPriceWithoutNoShippingItems >= minPriceForGift &&
          deliveryBarFinalTextEl
        ) {
          deliveryBarFinalTextEl.innerHTML = "Kostenloser Versand & Geschenk!";
        }
      }
    } else {
      if (giftIcon) {
        giftIcon.style.display = "none";
      }
      if (deliveryIcon) {
        deliveryIcon.style.left = "100%";
      }

      if (minSubtotalPriceValue > subtotalPriceWithoutNoShippingItems) {
        let remainingPrice =
          parseFloat(minSubtotalPriceValue) -
          parseFloat(subtotalPriceWithoutNoShippingItems);
        if (deliveryBarFinalTextEl) {
          deliveryBarFinalTextEl.style.display = "none";
        }
        if (deliveryBarLeftTextEl) {
          deliveryBarLeftTextEl.style.display = "block";
        }
        if (deliveryBarValueEl) {
          deliveryBarValueEl.textContent = safeFormatMoney(
            remainingPrice * 100
          );
        }
        if (deliveryBarStepLineEl) {
          deliveryBarStepLineEl.style.width =
            (
              (subtotalPriceWithoutNoShippingItems / minSubtotalPriceValue) *
              100
            ).toFixed(2) + "%";
        }
      } else {
        if (deliveryBarFinalTextEl) {
          deliveryBarFinalTextEl.style.display = "block";
          deliveryBarFinalTextEl.innerHTML = "Kostenloser Versand!";
        }
        if (deliveryBarLeftTextEl) {
          deliveryBarLeftTextEl.style.display = "none";
        }
        if (deliveryBarStepLineEl) {
          deliveryBarStepLineEl.style.width = "100%";
        }
      }
    }
  };

  const handleCheeringBarCH = (subtotalPrice, noDeliveryItemsTotalPrice) => {
    refreshCheeringBarElements();

    let subtotalPriceWithoutNoShippingItems =
      subtotalPrice - noDeliveryItemsTotalPrice;

    if (isGiftCheeringBarEnabled()) {
      let giftIconPosition;
      const minPriceForGift = parseFloat(window.cartDrawerMinPriceForGift);
      let percentPerEuro = 100 / parseFloat(minSubtotalPriceValue);

      giftIconPosition = minPriceForGift * percentPerEuro;

      if (giftIcon) {
        giftIcon.style.left = giftIconPosition + "%";
        giftIcon.style.right = "auto";
        giftIcon.style.display = "block";
      }
      if (deliveryIcon) {
        deliveryIcon.style.left = "100%";
      }

      if (subtotalPriceWithoutNoShippingItems < minPriceForGift) {
        let remainingPriceFreeGift =
          minPriceForGift - parseFloat(subtotalPriceWithoutNoShippingItems);

        if (deliveryBarFinalTextEl) {
          deliveryBarFinalTextEl.style.display = "block";
          deliveryBarFinalTextEl.textContent =
            "Noch " +
            safeFormatMoney(remainingPriceFreeGift * 100) +
            " bis zum Geschenk";
        }
        if (deliveryBarLeftTextEl) {
          deliveryBarLeftTextEl.style.display = "none";
        }
      } else {
        let remainingPriceFreeShipping =
          parseFloat(minSubtotalPriceValue) -
          parseFloat(subtotalPriceWithoutNoShippingItems);

        if (deliveryBarFinalTextEl) {
          deliveryBarFinalTextEl.style.display = "none";
        }
        if (deliveryBarLeftTextEl) {
          deliveryBarLeftTextEl.style.display = "block";
        }

        if (
          subtotalPriceWithoutNoShippingItems >= minSubtotalPriceValue &&
          deliveryBarLeftTextEl
        ) {
          deliveryBarLeftTextEl.innerHTML = "Kostenloser Versand & Geschenk!";
        } else if (deliveryBarLeftTextEl) {
          deliveryBarLeftTextEl.textContent =
            "Noch " +
            safeFormatMoney(remainingPriceFreeShipping * 100) +
            " bis zum kostenlosen Versand";
        }
      }

      if (deliveryBarStepLineEl) {
        deliveryBarStepLineEl.style.width =
          Math.min(
            subtotalPriceWithoutNoShippingItems * percentPerEuro,
            100
          ) + "%";
      }
    } else {
      if (giftIcon) {
        giftIcon.style.display = "none";
      }
      if (deliveryIcon) {
        deliveryIcon.style.left = "100%";
      }

      if (minSubtotalPriceValue > subtotalPriceWithoutNoShippingItems) {
        let remainingPriceFreeShipping =
          parseFloat(minSubtotalPriceValue) -
          parseFloat(subtotalPriceWithoutNoShippingItems);

        if (deliveryBarFinalTextEl) {
          deliveryBarFinalTextEl.style.display = "none";
        }
        if (deliveryBarLeftTextEl) {
          deliveryBarLeftTextEl.style.display = "block";
        }
        if (deliveryBarValueEl) {
          deliveryBarValueEl.textContent = safeFormatMoney(
            remainingPriceFreeShipping * 100
          );
        }
        if (deliveryBarStepLineEl) {
          deliveryBarStepLineEl.style.width =
            (
              (subtotalPriceWithoutNoShippingItems / minSubtotalPriceValue) *
              100
            ).toFixed(2) + "%";
        }
      } else {
        if (deliveryBarFinalTextEl) {
          deliveryBarFinalTextEl.style.display = "block";
          deliveryBarFinalTextEl.innerHTML = "Kostenloser Versand!";
        }
        if (deliveryBarLeftTextEl) {
          deliveryBarLeftTextEl.style.display = "none";
        }
        if (deliveryBarStepLineEl) {
          deliveryBarStepLineEl.style.width = "100%";
        }
      }
    }
  };

  const handleCheeringBarOtherLocation = (
    subtotalPrice,
    noDeliveryItemsTotalPrice
  ) => {
    refreshCheeringBarElements();

    let subtotalPriceWithoutNoShippingItems =
      subtotalPrice - noDeliveryItemsTotalPrice;

    if (giftIcon) {
      giftIcon.style.display = "none";
    }
    if (deliveryIcon) {
      deliveryIcon.style.left = "100%";
    }

    if (minSubtotalPriceValue > subtotalPriceWithoutNoShippingItems) {
      let remainingPriceFreeShipping =
        parseFloat(minSubtotalPriceValue) -
        parseFloat(subtotalPriceWithoutNoShippingItems);

      if (deliveryBarFinalTextEl) {
        deliveryBarFinalTextEl.style.display = "none";
      }
      if (deliveryBarLeftTextEl) {
        deliveryBarLeftTextEl.style.display = "block";
      }
      if (deliveryBarValueEl) {
        deliveryBarValueEl.textContent = safeFormatMoney(
          remainingPriceFreeShipping * 100
        );
      }
      if (deliveryBarStepLineEl) {
        deliveryBarStepLineEl.style.width =
          (
            (subtotalPriceWithoutNoShippingItems / minSubtotalPriceValue) *
            100
          ).toFixed(2) + "%";
      }
    } else {
      if (deliveryBarFinalTextEl) {
        deliveryBarFinalTextEl.style.display = "block";
        deliveryBarFinalTextEl.innerHTML = "Kostenloser Versand!";
      }
      if (deliveryBarLeftTextEl) {
        deliveryBarLeftTextEl.style.display = "none";
      }
      if (deliveryBarStepLineEl) {
        deliveryBarStepLineEl.style.width = "100%";
      }
    }
  };

  const showHideCheeringBar = () => {
    const cartItems = document.querySelectorAll(
      "#sidebar-cart .Cart__ItemList .CartItemWrapper[data-price]"
    );
    const cartMessageSteps = document.querySelector(
      "#sidebar-cart .CartMessage__Steps"
    );

    if (cartItems.length === 0 && cartMessageSteps) {
      cartMessageSteps.style.opacity = 0;
    } else if (cartMessageSteps) {
      cartMessageSteps.style.opacity = 1;
    }

    dispatchCheeringBarUpdatedEvent();
  };

  /******************************************************************/
  /* HELPER: Prüft ob eine Variante im Online Store verfügbar ist
  /* Geschenk-Produkte die nicht für den Online Store Channel published
  /* sind, können nicht per Cart API hinzugefügt werden → stiller Fallback.
  /******************************************************************/

  const isVariantAvailableForOnlineStore = async (variantId) => {
    try {
      const response = await fetch(`/variants/${variantId}.js`, {
        credentials: "same-origin",
      });
      if (!response.ok) {
        // 404 = Variante existiert nicht oder nicht im Online Store published
        console.warn(
          `[Gift] Variante ${variantId} nicht verfügbar (HTTP ${response.status}) – Geschenk wird übersprungen.`
        );
        return false;
      }
      const variant = await response.json();
      // available = true bedeutet auf Lager UND für diesen Channel published
      if (!variant.available) {
        console.warn(
          `[Gift] Variante ${variantId} ist nicht verfügbar (ausverkauft oder nicht published) – Geschenk wird übersprungen.`
        );
        return false;
      }
      return true;
    } catch (error) {
      console.warn(`[Gift] Verfügbarkeitsprüfung für Variante ${variantId} fehlgeschlagen:`, error);
      return false;
    }
  };

  /******************************************************************/
  /* FREE GIFT 2
  /* Simples Geschenk: wird hinzugefügt wenn Cart > cartDrawerGift2MinPrice,
  /* entfernt wenn darunter. Kein CheeringBar. Eigener on/off Switch.
  /******************************************************************/

  const handleFreeGift2 = async () => {
    if (isFreeGift2Processing) {
      if (DEBUG_CART_DRAWER) {
        console.log("handleFreeGift2: bereits in Verarbeitung, übersprungen.");
      }
      return;
    }

    isFreeGift2Processing = true;

    const gift2VariantId = window.cartDrawerGift2VariantId
      ? parseInt(window.cartDrawerGift2VariantId)
      : null;

    if (!gift2VariantId) {
      isFreeGift2Processing = false;
      return;
    }

    const minPriceForGift2 = parseFloat(window.cartDrawerGift2MinPrice) || 1;

    try {
      const cartResponse = await fetch("/cart.js", { credentials: "same-origin" });
      if (!cartResponse.ok) throw new Error("cart.js fetch failed");
      const cart = await cartResponse.json();

      // Subtotal ohne Gift-1 und Gift-2 selbst berechnen
      const gift1VariantIdForExclusion = window.cartDrawerGiftVariantId
        ? parseInt(window.cartDrawerGiftVariantId)
        : null;

      const subtotalExcludingGifts = cart.items.reduce((sum, item) => {
        if (item.variant_id === gift2VariantId) return sum;
        if (gift1VariantIdForExclusion && item.variant_id === gift1VariantIdForExclusion) return sum;
        // Digitale Produkte (kein Versand erforderlich) nicht zum Threshold zählen
        // — analog zu handleFreeGift, das im DOM auf data-req-shipping="false" filtert.
        if (item.requires_shipping === false) return sum;
        return sum + item.final_line_price;
      }, 0) / 100;

      const gift2InCart = cart.items.some(
        (item) => item.variant_id === gift2VariantId
      );
      const gift2Qty = cart.items.find(
        (item) => item.variant_id === gift2VariantId
      )?.quantity ?? 0;

      if (subtotalExcludingGifts >= minPriceForGift2 && !gift2InCart) {
        // FIX: Race-Condition-Guard – frischen Cart holen bevor wir hinzufügen,
        // damit ein paralleler Handler das Gift nicht doppelt einfügt
        const freshCartResp = await fetch("/cart.js", { credentials: "same-origin" });
        const freshCart = await freshCartResp.json();
        const alreadyAdded = freshCart.items.some(item => item.variant_id === gift2VariantId);
        if (alreadyAdded) {
          isFreeGift2Processing = false;
          return;
        }

        const available = await isVariantAvailableForOnlineStore(gift2VariantId);
        if (available) {
          await updateCart({ updates: { [gift2VariantId]: 1 } });
        }
      } else if (subtotalExcludingGifts >= minPriceForGift2 && gift2InCart && gift2Qty > 1) {
        // Menge auf 1 korrigieren falls manuell erhöht
        await updateCart({ updates: { [gift2VariantId]: 1 } });
      } else if (subtotalExcludingGifts < minPriceForGift2 && gift2InCart) {
        await updateCart({ updates: { [gift2VariantId]: 0 } });
      }
    } catch (error) {
      console.error("Error in handleFreeGift2:", error);
    } finally {
      isFreeGift2Processing = false;
    }
  };

  /******************************************************************/
  /* FREE GIFT
  /******************************************************************/

  const handleFreeGift = async () => {
    if (isFreeGiftProcessing) {
      if (DEBUG_CART_DRAWER) {
        console.log("handleFreeGift: bereits in Verarbeitung, übersprungen.");
      }
      return;
    }

    isFreeGiftProcessing = true;

    const cartItems = document.querySelectorAll(
      ".Drawer__Container .CartItemWrapper[data-price]"
    );
    let subtotalPrice = parseFloat(
      getSidebarCartValuesEl()?.dataset.cartTotalPriceFloat || 0
    );
    let noDeliveryItemsTotalPrice = 0;

    const giftVariantId = window.cartDrawerGiftVariantId
      ? parseInt(window.cartDrawerGiftVariantId)
      : null;

    // Gift-1 und Gift-2 aus Subtotal-Berechnung ausschließen
    const gift2VariantIdForExclusion = window.cartDrawerGift2VariantId
      ? parseInt(window.cartDrawerGift2VariantId)
      : null;

    cartItems.forEach((cartItem) => {
      const itemVariantId = cartItem.dataset.variantId
        ? parseInt(cartItem.dataset.variantId)
        : null;

      if (giftVariantId && itemVariantId === giftVariantId) {
        return;
      }
      if (gift2VariantIdForExclusion && itemVariantId === gift2VariantIdForExclusion) {
        return;
      }

      if (cartItem.dataset.reqShipping == "false") {
        noDeliveryItemsTotalPrice += parseFloat(cartItem.dataset.price / 100);
      }
    });

    subtotalPrice = subtotalPrice - noDeliveryItemsTotalPrice;

    const minPriceForGift = parseFloat(window.cartDrawerMinPriceForGift);

    try {
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      const giftContained = cart.items.some(
        (cartItem) =>
          cartItem.variant_id === parseInt(window.cartDrawerGiftVariantId)
      );
      const giftQty = cart.items.find(
        (cartItem) =>
          cartItem.variant_id === parseInt(window.cartDrawerGiftVariantId)
      )?.quantity ?? 0;

      /** PRODUCT SPECIFIC GIFTS **/
      const triggeringCartItems = document.querySelectorAll(
        ".CartItemWrapper[data-triggers]"
      );
      const triggeringItemsSet = [];

      triggeringCartItems.forEach((triggerItem) => {
        const triggerItemQty = parseInt(
          triggerItem.querySelector(".QuantitySelector__CurrentQuantity")
            ?.value || 0
        );
        const triggeredGiftId = parseInt(triggerItem.dataset.triggers);
        const existingItem = triggeringItemsSet.find(
          (item) => item.id === triggeredGiftId
        );

        if (existingItem) {
          existingItem.qty += triggerItemQty;
        } else {
          triggeringItemsSet.push({
            id: triggeredGiftId,
            qty: triggerItemQty,
          });
        }
      });

      const giftItems = document.querySelectorAll(
        ".CartItemWrapper.cartGiftItem"
      );

      giftItems.forEach((giftItem) => {
        const giftItemVariantId = parseInt(giftItem.dataset.variantId);
        const triggerItem = document.querySelector(
          '.CartItemWrapper[data-triggers="' + giftItemVariantId + '"]'
        );

        if (
          triggerItem == null &&
          giftItemVariantId != parseInt(window.cartDrawerGiftVariantId)
        ) {
          triggeringItemsSet.push({ id: giftItemVariantId, qty: 0 });
        }
      });

      /** END PRODUCT SPECIFIC GIFTS **/

      // Gift-2-Variante niemals durch Gift-1-Logik anfassen
      const gift2VariantIdSafe = window.cartDrawerGift2VariantId
        ? parseInt(window.cartDrawerGift2VariantId)
        : null;
      if (gift2VariantIdSafe) {
        const idx = triggeringItemsSet.findIndex((i) => i.id === gift2VariantIdSafe);
        if (idx !== -1) triggeringItemsSet.splice(idx, 1);
      }

      if (subtotalPrice < minPriceForGift && giftContained) {
        const cartUpdates = {
          updates: {
            [window.cartDrawerGiftVariantId]: 0,
          },
        };

        triggeringItemsSet.forEach((item) => {
          cartUpdates.updates[item.id] = item.qty;
        });

        await updateCart(cartUpdates);
      } else if (giftContained && subtotalPrice >= minPriceForGift && giftQty > 1) {
        // Menge auf 1 korrigieren falls manuell erhöht
        const cartUpdates = {
          updates: {
            [window.cartDrawerGiftVariantId]: 1,
          },
        };
        triggeringItemsSet.forEach((item) => {
          cartUpdates.updates[item.id] = item.qty;
        });
        await updateCart(cartUpdates);
      } else if (!giftContained && subtotalPrice >= minPriceForGift) {
        // FIX: Race-Condition-Guard – frischen Cart holen bevor wir hinzufügen,
        // damit ein paralleler Handler das Gift nicht doppelt einfügt
        const freshCartResp2 = await fetch("/cart.js", { credentials: "same-origin" });
        const freshCart2 = await freshCartResp2.json();
        const giftAlreadyAdded = freshCart2.items.some(
          item => item.variant_id === parseInt(window.cartDrawerGiftVariantId)
        );
        if (giftAlreadyAdded) {
          window.unlockCheckoutButton();
          isFreeGiftProcessing = false;
          return;
        }

        const available = await isVariantAvailableForOnlineStore(
          parseInt(window.cartDrawerGiftVariantId)
        );
        if (!available) {
          window.unlockCheckoutButton();
          return;
        }
        const cartUpdates = {
          updates: {
            [window.cartDrawerGiftVariantId]: 1,
          },
        };

        triggeringItemsSet.forEach((item) => {
          cartUpdates.updates[item.id] = item.qty;
        });

        await updateCart(cartUpdates);
      } else if (triggeringItemsSet.length > 0) {
        const cartUpdates = {
          updates: {},
        };

        triggeringItemsSet.forEach((item) => {
          cartUpdates.updates[item.id] = item.qty;
        });

        if (Object.keys(cartUpdates.updates).length > 0) {
          await updateCart(cartUpdates);
        } else {
          window.unlockCheckoutButton();
        }
      } else {
        window.unlockCheckoutButton();
      }
    } catch (error) {
      console.error("Error in handleFreeGift:", error);
      window.unlockCheckoutButton();
    } finally {
      isFreeGiftProcessing = false;
    }
  };

  /******************************************************************/
  /* HELPER: UPDATE CART
  /******************************************************************/

  const updateCart = async (cartUpdates) => {
    try {
      const updateResponse = await fetch(
        window.Shopify.routes.root + "cart/update.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(cartUpdates),
        }
      );

      if (!updateResponse.ok) {
        throw new Error(
          `Update request failed with status ${updateResponse.status}`
        );
      }

      const updatedCart = await updateResponse.json();
      const cartValuesEl = getSidebarCartValuesEl();
      if (cartValuesEl && updatedCart.total_price !== undefined) {
        cartValuesEl.dataset.cartTotalPriceFloat = (
          updatedCart.total_price / 100
        ).toFixed(2);
      }

      const pageResponse = await fetch(window.location.href);

      if (!pageResponse.ok) {
        throw new Error(
          `Page fetch failed with status ${pageResponse.status}`
        );
      }

      const responseText = await pageResponse.text();
      const oldItemsWrapper = document.querySelector(".Cart__ItemList");
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const newItemsWrapper = html.querySelector(".Cart__ItemList");

      const newCartValuesEl = html.querySelector(".Cart__values");
      if (newCartValuesEl && cartValuesEl) {
        Array.from(newCartValuesEl.attributes).forEach((attr) => {
          if (attr.name.startsWith("data-")) {
            cartValuesEl.setAttribute(attr.name, attr.value);
          }
        });
      }

      if (newItemsWrapper && oldItemsWrapper) {
        oldItemsWrapper.innerHTML = newItemsWrapper.innerHTML;
      } else {
        location.reload();
      }

      setTimeout(() => {
        window.unlockCheckoutButton();
      }, 1000);
    } catch (error) {
      console.error("Error updating the cart:", error);
      setTimeout(() => {
        window.unlockCheckoutButton();
      }, 1000);
    }
  };

  /******************************************************************/
  /* TOTAL CALCULATION
  /******************************************************************/

  const totalCalculation = (isDcart) => {
    const cartItems = document.querySelectorAll(
      ".Drawer__Container .CartItemWrapper[data-price]"
    );
    const subTotalPriceCompareAtEl = document.querySelector(
      ".Drawer__Footer__Subtotal .Drawer__Footer__SubtotalPrice .Drawer__Footer__SubtotalPrice_Compare-at"
    );
    const subTotalPriceEl = document.querySelector(
      ".Drawer__Footer__Subtotal .Drawer__Footer__SubtotalPrice .Drawer__Footer__SubtotalPrice_Value"
    );
    const deliveryCostEl = document.querySelector(
      ".Drawer__Footer__Delivery span"
    );
    const totalPriceEl = document.querySelector(
      ".Drawer__Footer__Total span"
    );
    const cartValuesEl = getSidebarCartValuesEl();

    let subTotalPrice;
    let scCompareAtPrice;
    let noDeliveryItemsTotalPrice = 0;

    if (isDcart) {
      subTotalPrice = scData?.subtotalCents / 100;
      scCompareAtPrice = scData?.totalCents / 100;
    } else {
      subTotalPrice = parseFloat(
        cartValuesEl?.dataset.cartTotalPriceFloat || 0
      );
    }

    let shippingRate = shippingPrice;
    let hasItemWithDeliveryRequired = false;

    cartItems.forEach((cartItem) => {
      if (cartItem.dataset.reqShipping == "false") {
        noDeliveryItemsTotalPrice += parseFloat(cartItem.dataset.price / 100);
      } else {
        hasItemWithDeliveryRequired = true;
      }
    });

    let subtotalPriceWithoutNoShippingItems =
      subTotalPrice - noDeliveryItemsTotalPrice;

    if (subTotalPrice > 0) {
      if (
        subtotalPriceWithoutNoShippingItems >= parseFloat(minSubtotalPriceValue)
      ) {
        shippingRate = 0;
      }

      let subtotalPriceFormatted = safeFormatMoney(subTotalPrice * 100);

      if (
        subtotalPriceWithoutNoShippingItems >= parseFloat(minSubtotalPriceValue)
      ) {
        let totalPrice = parseFloat(subTotalPrice) + parseFloat(shippingRate);
        let totalPriceFormatted = safeFormatMoney(
          totalPrice.toFixed(2) * 100
        );

        if (subTotalPriceEl) {
          subTotalPriceEl.textContent = subtotalPriceFormatted;
        }
        if (deliveryCostEl) {
          deliveryCostEl.textContent = deliveryCostEl.getAttribute(
            "data-freeshipping-text"
          );
          deliveryCostEl.classList.add("highlight-free-shipping");
        }
        if (totalPriceEl) {
          totalPriceEl.textContent = totalPriceFormatted;
        }
      } else {
        if (!hasItemWithDeliveryRequired) {
          if (deliveryCostEl) {
            deliveryCostEl.textContent = deliveryCostEl.getAttribute(
              "data-freeshipping-text"
            );
            deliveryCostEl.classList.add("highlight-free-shipping");
          }

          if (subTotalPriceEl) {
            subTotalPriceEl.textContent = subtotalPriceFormatted;
          }
          if (totalPriceEl) {
            totalPriceEl.textContent = subtotalPriceFormatted;
          }
        } else {
          shippingRate = shippingPrice;
          let shippingPriceFormatted = safeFormatMoney(shippingRate * 100);
          let totalPrice =
            parseFloat(subTotalPrice) + parseFloat(shippingRate);
          let totalPriceFormatted = safeFormatMoney(
            totalPrice.toFixed(2) * 100
          );

          if (subTotalPriceEl) {
            subTotalPriceEl.textContent = subtotalPriceFormatted;
          }
          if (deliveryCostEl) {
            if (
              subtotalPriceWithoutNoShippingItems >=
              parseFloat(minSubtotalPriceValue)
            ) {
              deliveryCostEl.textContent = deliveryCostEl.getAttribute(
                "data-freeshipping-text"
              );
              deliveryCostEl.classList.add("highlight-free-shipping");
            } else {
              deliveryCostEl.textContent = shippingPriceFormatted;
              deliveryCostEl.classList.remove("highlight-free-shipping");
            }
          }
          if (totalPriceEl) {
            totalPriceEl.textContent = totalPriceFormatted;
          }
        }
      }

      if (isDcart) {
        if (
          scData?.subtotalCents !== scData?.totalCents &&
          subTotalPriceCompareAtEl
        ) {
          let scCompareAtPriceFormatted = safeFormatMoney(
            scCompareAtPrice * 100
          );
          subTotalPriceCompareAtEl.textContent = scCompareAtPriceFormatted;
        }
      }
    }
  };

  /******************************************************************/
  /* DCART
  /******************************************************************/

  const toggleDCart = () => {
    const cartDrawer = document.querySelector("#sidebar-cart");
    if (!cartDrawer) return;

    cartDrawer.removeEventListener("click", handleCouponClick);
    cartDrawer.addEventListener("click", handleCouponClick);
  };

  function handleCouponClick(event) {
    const couponTitle = event.target.closest(".Drawer__Footer__Coupon-title");
    if (couponTitle) {
      const cartDrawer = document.querySelector("#sidebar-cart");
      cartDrawer.classList.toggle("Drawer__Footer__CouponActive");
      if (
        currentCountry !== "DE" &&
        currentCountry !== "AT" &&
        currentCountry !== "CH"
      ) {
        cartDrawer.classList.toggle(
          "Drawer__Footer__CouponActive--other-location"
        );
      }
    }
  }

  const dCartCalculation = () => {
    const cartDrawerElement = document.querySelector("#sidebar-cart");

    const dCartObserver = new MutationObserver((mutationsList, observer) => {
      observer.disconnect();

      scData = getSafeScDiscountData();

      if (scData?.code) {
        cartDrawerElement.classList.add("Drawer--hasCoupon");
      } else {
        cartDrawerElement.classList.remove("Drawer--hasCoupon");
      }

      if (
        (scData?.stage === "complete" && scData?.subtotalCents > 0) ||
        (scData?.stage === "initial" && scData?.subtotalCents > 0)
      ) {
        const couponPercentage = document.querySelector(
          "#sidebar-cart .Drawer__Footer__Coupon-percentage"
        );

        if (scData?.code && couponPercentage) {
          const saving = parseFloat(scData?.discount?.amount) * 100;
          couponPercentage.textContent = "-" + safeFormatMoney(saving);
        }

        if (scData?.gifts?.length > 0 && couponPercentage) {
          const saving = parseFloat(scData?.gifts[0]?.amount_used) * 100;
          couponPercentage.textContent = "-" + safeFormatMoney(saving);
        }

        cheeringBar();
        totalCalculation(true);
      }
    });

    if (cartDrawerElement) {
      dCartObserver.observe(cartDrawerElement, {
        childList: true,
        subtree: true,
      });
    }
  };

  /******************************************************************/
  /* Black Week Badge
  /******************************************************************/

  const blackWeekBadge = () => {
    const blackWeekBadgeElement = document.querySelector(
      "[data-js-black-week-badge]"
    );
    if (!blackWeekBadgeElement) return;

    const mutationObserverPrice = new MutationObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.type == "childList") {
          if (entry.target.classList.contains("Badge__Savings")) return;
          const cartSavingsElement = document.querySelector(
            "[data-js-black-week-cart-savings]"
          );

          if (!cartSavingsElement) return;

          const cartSavings = cartSavingsElement.getAttribute(
            "data-js-black-week-cart-savings"
          );
          const badgeSavingsElement = document.querySelector(
            "[data-js-black-week-badge-savings]"
          );

          if (badgeSavingsElement && badgeSavingsElement.innerText !== cartSavings) {
            badgeSavingsElement.innerText = cartSavings;
          }
        }
      });
    });

    const cartDrawer = document.querySelector("#shopify-section-cart-drawer");

    if (cartDrawer != undefined) {
      mutationObserverPrice.observe(cartDrawer, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }
  };

  document.addEventListener("DOMContentLoaded", blackWeekBadge);
})();